<template>
  <div :class="[{'content-box content-box-plus': !disableCard}, { 'no-card': disableCard }]">
    <div class="m-2 text-center" v-show="isLoading">
      <font-awesome-icon
        :icon="['fa', 'circle-notch']"
        class="fa-spin m-auto spinner fa-5x egx-partner-color"
      />
    </div>
    <div :class="['card-body', { 'no-card': disableCard }]" v-if="!isLoading">
      <div class="row">
        <div class="col-12">
          <div class="title">
            <span class="step-title mb-4" v-html="stepTitle" />
          </div>
          <div class="step-description" v-html="stepConfiguration.main_instructions" v-if="!this.queryHideInst && stepConfiguration.main_instructions"/>
        </div>
      </div>

      <component
        :is="getComponent2(queryStepType)"
        :content="content"
        :navigate="navigateNextStep"
        :project-id="projectId"
        :project-status="projectStatus"
        :steps-response="stepsResponse"
        :step-configuration="stepConfiguration"
        :key="queryStepNumber"
        :fulfill-sync-details="fulfillSyncDetails"
        :measuresSize="projecMeasuresLength"
        @selected-contact-id="storeSelectedContact"
      />
      <step-button
        :steps-response="stepsResponse"
        @navigate="navigateNextStep"
        @save-data="saveContact"
        :data-save-required="true"
        v-if="showFooterButton"
      />
    </div>
  </div>
</template>

<script>
import Contact from './Contact.vue';
import DetailSection from './project/DetailSection.vue';
import StepButton from './project/stepButton.vue';
import redirectPath from '@/shared/mixins/redirect-path';
import projectMixins from '@/shared/mixins/projectMixins';
import Measure from './project/Measures.vue';
import ProjectMeasuresList from './project/ProjectMeasuresList.vue';
import ProjectCart from './project/ProjectCart.vue';
import TermsAndConditions from './project/TermsAndConditions.vue';
import router from "@/router";

export default {
  components: {
    Contact,
    DetailSection,
    StepButton,
    Measure,
    ProjectMeasuresList,
    ProjectCart,
    TermsAndConditions
  },

  mixins: [redirectPath, projectMixins],

  props: {
    content: Object,
    step: Number
  },

  data() {
    return {
      disableCard: false,
      // showFooterButton: true,
      query: this.$route.query,
      nextPageParams: {},
      projectId: this.$route.params.id,
      projectStatus: null,
      providedStatus: null,
      stepsResponse: {
        curStep: '0',
      },
      stepUrlParams: {},
      isLoading: false,
      selectedContactId: null,
      stepConfiguration: {},
      projecMeasuresLength: 0,
      isSmallScreen: window.innerWidth <= 768,
      nav: 'cs',
    };
  },

  created() {
    const project_id = this.$route.params.id;
    if (project_id) {
      this.isLoading = true;
      this.$store.dispatch('fulfill_integrate/get_project_selected', { project_id })
      .then((response) => {
        if(this.locked(response.project) || this.isNotUserProject(response.project)) {
          this.$router.push('/applications');
          return
        } else {
          this.projecMeasuresLength = response.project.retrofits.length;
          if (!this.queryStepNumber) { this.nav = 'ns'; }
          this.navigateNextStep(this.nav, true);
        }
      })
      .catch((error) => {
        this.isVisible = false;
        console.log(error);
        this.notifyInitialProjectCreationError();
        this.$router.push({ name: 'Offers' });
      });
    }
    window.addEventListener('resize', this.updateScreenSize);

    window.addEventListener('popstate', this.handlePopState);
    window.addEventListener('keydown', this.handleKeyDown);
  },

  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
    window.removeEventListener('keydown', this.handleKeyDown);
  },

  computed: {
    queryStepNumber() {
      return this.$route.query.cs;
    },

    currentStepId() {
      return this.$route.query.cn;
    },

    queryStepType() {
      return this.$route.query.type;
    },

    queryHideInst() {
      return this.$route.query.hideinst === 'true';
    },

    queryHideTitle() {
      return this.$route.query.hidetitle === 'true';
    },

    totalSteps() {
      return Number(this.stepsResponse.step_num) + Number(this.stepsResponse.steps_remaining) - 1;
    },

    stepTitle() {
      const title = this.queryHideTitle ? '' : this.stepConfiguration.title ? `: ${this.stepConfiguration.title}` : `: ${this.stepsResponse.step_name}`;
      return `Step ${this.stepsResponse.step_num} of ${this.totalSteps}${title}`;
    },

    showFooterButton() {
      return this.queryStepType === 'contact';
    },

    settings() {
      return this.$store.state.partners.currentPartner.settings;
    },

    fulfillSyncDetails() {
      return this.settings.fulfill_sync_details;
    },
    cartSettings() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details.settings.project_measures_cart || {};
    },

    currentUser() {
      return this.$store.state.users.currentUser;
    },

    isGuestUser() {
      return ['guest', 'test_guest'].includes(this.currentUser.user_type);
    },

    currentSelectedProject() {
      return this.$store.state.fulfill_integrate.currentSelectedProject;
    },
  },

  methods: {
    navigateNextStep(nav = 'ns', onCreate = false) {
      this.isLoading = true;
      this.nav = nav;
      let updatedStepNumber = this.queryStepNumber || 0;

      if (onCreate && this.queryStepNumber && this.stepsResponse.step_url) { return; }

      if (onCreate && updatedStepNumber > 0){
        updatedStepNumber -= 1;
      }

      const params = {
        cn: this.currentStepId,
        curStep: updatedStepNumber,
        nav: nav,
        projectId: this.projectId,
        onCreate: onCreate,
      }
      this.getPortalStepsAndConfigurations(params, true);
    },

    getComponent2(type) {
      switch (type) {
        case 'contact':
          return 'Contact';
        case 'prq':
          return 'DetailSection';
        case 'attachment':
          return 'DetailSection';
        case 'tandc':
          return 'TermsAndConditions';
        case 'measurelist':
          return 'Measure';
        case 'measuredetails':
          return 'ProjectMeasuresList';
        default:
          return 'Contact';
      }
    },

    storeSelectedContact(id) {
      this.selectedContactId = id;
    },

    async saveContact(step) {
      const project_id = this.$route.params.id;
      this.$store.dispatch('fulfill_integrate/get_project_selected', { project_id })
        .then((response) => {
          if(this.locked(response.project)) {
            this.$notify({
              group: 'notice-stay',
              type: 'error',
              text: 'This project is locked in the portal.',
            });
            this.$router.push('/applications');
            return
          }
        })
        .catch((error) => {
          this.isVisible = false;
          console.log(error);
        });
      if (this.selectedContactId) {
        this.isLoading = true;

        await this.$store.dispatch('fulfill_integrate/updateProjectPrimaryContact', {
          project_id: this.projectId,
          contact_id: this.selectedContactId,
        }).then((response) => {
          this.isLoading = false;
          this.$notify({
            group: 'notice',
            text: response.message,
          });

          if (step === 'nextStep') {
            this.navigateNextStep();
          } else if (step === 'linkStep') {
            this.redirectPath(this.stepsResponse.add_btn_url);
          }
        }).catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.$notify({
            group: 'notice-stay',
            type: 'error',
            text: error.error,
          });
        });
      } else {
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: 'Please select a contact before proceeding to the next step.',
        });
      }
    },

    handlePopState() {
      this.isLoading = true;

      const params = {
        cn: this.currentStepId,
        curStep: Number(this.queryStepNumber),
        nav: 'cs',
        projectId: this.projectId,
      }
      this.getPortalStepsAndConfigurations(params);
    },

    getPortalStepsAndConfigurations(params, redirectPath) {
      this.$store.dispatch('fulfill_integrate/getPortalSteps', params).then((response) => {
        this.stepsResponse = response;
        this.projectStatus = response.project_status;
        const updatedUrl = this.stepsResponse.step_url.replaceAll('$PID$', this.projectId);
        if (this.$route.fullPath !== updatedUrl) {
          if (response.steps_remaining === '0') {
            this.$notify({
              group: 'notice',
              text: this.fulfillSyncDetails.messages.finish_steps,
            });

            if (this.isGuestUser) {
              const that = this;
              this.$store.dispatch('auth/signOut').then(() => {
                if (this.fulfillSyncDetails?.allow_transition_page_for_steps) {
                  const event = new CustomEvent('applicationEvent', {
                    detail: { projectAction: 'submit', projectId: that.currentSelectedProject.id },
                    bubbles: true,
                    cancelable: false,
                  })
                  window.parent.document.dispatchEvent(event);
                  this.$router.push('/please-wait?mode=submit');
                } else if (redirectPath) {
                  this.redirectPath(updatedUrl);
                } else {
                  this.$router.push('/offers-public');
                }
                return;
              });
            }
          }

          if (redirectPath) {
            this.redirectPath(updatedUrl);
          }
        }
        }).catch((error) => {
          console.log(error);
          this.notifyInitialProjectCreationError();
          this.$router.push('/applications');
          return
        }).finally(() => {
          this.$store.dispatch('fulfill_integrate/getPageConfiguration', {
            task_name: this.getStepConfigurationType(),
            project_id: this.$route.params.id,
            cur_step_name: this.stepsResponse.id
          })
          .then((response) => {
            this.stepConfiguration = response;
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.notifyInitialProjectCreationError();
            this.$router.push('/applications');
            this.isLoading = false;
            return
          });
        });
    },

    getStepConfigurationType() {
      if (this.$route.query.type === 'prq') {
        return 'response';
      } else if (this.queryStepType === 'measurelist') {
        return 'measuresearch';
      } else if (this.queryStepType === 'measuredetails') {
        return 'measurecart';
      }
      return this.$route.query.type;
    },

    handleKeyDown(event) {
      const target = event.target;
      const isTextArea = target.tagName === 'TEXTAREA';
      const isContentEditable = target.isContentEditable;
      const isInput = target.tagName === 'INPUT';
      const shouldPrevent = isInput || (!isTextArea && !isContentEditable);

      if (event.key === 'Enter' && shouldPrevent) {
        event.preventDefault();
      }
    },

    notifyInitialProjectCreationError() {
      this.$notify({
        group: 'notice-stay',
        type: 'error',
        text: this.fulfillSyncDetails.messages.initial_project_creation_error || 'An error occurred while creating your project. Please contact support or your system administrator.',
      });
    },
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .mr-4, .ml-4, .mb-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .row {
    flex-direction: column;
  }

  .col-12 {
    width: 100%;
  }

  .step-title {
    text-align: center;
  }

  .cart-small {
    margin-top: 1rem;
  }
}

#application-wrapper .content-box {
  margin: auto;
  overflow: visible;
}
.row {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}
.col-6 {
  flex: 1;
}
.col-9 {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.col-3 {
  flex: 1;
  margin-left: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-small {
  transform: scale(0.8);
}

.step-header {
  margin-top: 0;
}

</style>
